<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Review Applicant Profile</h4>
        <p class="category">Approve/Reject this Applicant</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>First Name</label>
              <md-input v-model="firstName" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="lastName" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Email Address</label>
              <md-input v-model="emailadress" type="email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Company</label>
              <md-input v-model="companyName"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Adress</label>
              <md-input v-model="address" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button
              class="md-raised md-success"
              v-on:click="reviewApplication(applicantId, 'approve', '1')"
              >Approve</md-button
            >
            <md-button
              class="md-raised md-danger"
              v-on:click="reviewApplication(applicantId, 'decline', '0')"
              >Reject</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import api from "@/service/api.js";
import { BASE_URL, BUBBLE_API_URL, API_BASE_URL } from "@/constants/";

export default {
  name: "edit-profile-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    },
    applicantId: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      companyName: null,
      emailadress: null,
      address: null
    };
  },
  methods: {
    async getApplicant(applicantId) {
      const GET_SINGLE_APPLICANT_URL =
        BUBBLE_API_URL + "/partnerapplication/" + applicantId;
      const request = await api.get(GET_SINGLE_APPLICANT_URL);
      const response = await request.json();

      this.firstName = response.response["First Name"];
      this.lastName = response.response["Last Name"];
      this.companyName = response.response["Company Name"];
      this.address = response.response["Address"];
    },
    async reviewApplication(applicantId, type, status) {
      const APPROVE_URL = BUBBLE_API_URL + "/partnerapplication/" + applicantId;
      const BUBBLE_API_KEY = process.env.VUE_APP_BUBBLE_API_KEY;
      const opts = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + BUBBLE_API_KEY
        },
        body: JSON.stringify({
          Status: status
        })
      };
      const request = await api.patch(APPROVE_URL, opts);

      const notifyConfig = {
        message: "Applicant Succesfully Approved.",
        icon: "check",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success"
      };

      if (type === "decline") {
        notifyConfig.message = "Applicant has been declined.";
        notifyConfig.icon = "notification_important";
        notifyConfig.type = "danger";
      }

      if (request.ok && request.status === 204) {
        this.$notify(notifyConfig);
      }
    }
  },
  created() {
    const applicantId = this.$props.applicantId;
    this.getApplicant(applicantId);
  }
};
</script>
<style></style>
